<template>
  <el-dialog
      v-if="currentProfile"
      class="profile-dialog"
      title="Мой профиль"
      :visible.sync="form.show"
      width="350px"
      @submit.prevent.native=""
      :before-close="handleClose">

    <div v-show="page === 'menu'">
      <div class="profile-dialog__info">
        <el-avatar :style="{background: avatarColor(currentProfile.id)}">{{ avatarChar(currentProfile.name) }}
        </el-avatar>
        <div class="profile-dialog__contacts">
          <span class="profile-dialog__name">{{ currentProfile.name }}</span>
          <span class="profile-dialog__email">{{ currentProfile.email }}</span>
        </div>
      </div>
      <el-menu @select="handleSelect" class="dialog-menu">
        <el-menu-item class="dialog-menu__item" index="password"><i class="el-icon-lock"></i>Сменить пароль
        </el-menu-item>
        <el-menu-item class="dialog-menu__item" index="logout"><i class="el-icon-switch-button"></i>Выход</el-menu-item>
      </el-menu>
    </div>
    <div v-if="page === 'password'">
      <el-form size="mini" :model="password" ref="form" :rules="rules">
        <el-form-item label="Старый пароль" prop="password_old" :error="error">
          <el-input type="password" v-model="password.password_old" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Новый пароль" prop="password">
          <el-input type="password" v-model="password.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Повторите пароль" prop="password_confirmation">
          <el-input type="password" v-model="password.password_confirmation" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <span v-if="page === 'password'" slot="footer" class="dialog-footer">
            <el-button @click="page = 'menu'" size="mini" :disabled="loading">Отмена</el-button>
            <el-button @click="changePassword" type="primary" size="mini" :disabled="loading">Сохранить</el-button>
      </span>

    </div>

  </el-dialog>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "ProfileDialog",
  data() {

    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Введите новый пароль'));
      } else {
        if (this.password.password_confirmation !== '') {
          this.$refs.form.validateField('password_confirm');
        }
        callback();
      }
    };
    let validatePassConfirm = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Подтвердите новый пароль'));
      } else if (value !== this.password.password) {
        callback(new Error('Пароли не совпадают!'));
      } else {
        callback();
      }
    };

    return {
      error: null,
      visible: true,
      loading: false,
      page: 'menu',
      password: {
        password_old: '',
        password: '3434',
        password_confirmation: ''
      },
      rules: {
        password_old: [
          {required: true, message: 'Введите старый пароль', trigger: 'blur'},
        ],
        password: [
          {required: true, validator: validatePass, trigger: 'blur'},
        ],
        password_confirmation: [
          {required: true, validator: validatePassConfirm, trigger: 'blur'},
        ],
      },
    }
  },
  computed: {
    ...mapState('auth', {
      currentProfile: state => state.profile,
    }),
    ...mapState('dialogs/profile', {
      form: state => state,
    }),
  },
  methods: {
    ...mapActions({
      close: 'dialogs/profile/clear',
    }),
    ...mapMutations({}),
    avatarColor(id) {
      let colors = [
        "#ec8a41",
        "#4174ec",
        "#6541ec",
        "#ec6263",
        "#4bafec",
        "#9774ec",
      ];
      let color = id % colors.length;
      return colors[color];
    },
    avatarChar(name) {
      return name.charAt(0).toUpperCase();
    },
    handleSelect(menu) {
      if (menu === 'password') {
        this.password.password_old = '';
        this.password.password = '';
        this.password.password_confirmation = '';
        this.page = menu;
      }
      if (menu === 'logout') {
        this.$store.dispatch('auth/LOGOUT').then(() => {
          this.close()
          this.$router.push({name: 'auth.signin'});
        });

      }
    },
    handleClose() {
      this.close()
    },
    changePassword() {
      this.error = null;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          this.$api.auth.changePass(this.password).then(() => {
            this.page = 'menu';
            this.$message({
              message: 'Пароль успешно сброшен.',
              type: 'success'
            });
          }).catch(() => {
            this.error = 'Проверьте правильность заполнения';
          }).finally(() => {
            this.loading = false;
          })
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">
.profile-dialog {

  &__info {
    display: flex;
    justify-content: left;
    align-items: center;
    margin: 25px 0;
  }

  &__contacts {
    margin-left: 15px;
  }

  &__email {
    display: flex;
  }

  &__name {
    font-weight: 500;
    font-size: 18px;
    display: flex;
  }

}

.dialog-menu {
  margin-left: -20px;
  margin-right: -20px;

  &__item {
    display: flex;
    align-items: center;
  }
}
</style>
